export type CompressionTargetPreset = 'none' | '5mb'
export type CompressionLandingSource = 'direct' | 'legacy_redirect'

export const TARGET_SIZE_PRESETS: readonly CompressionTargetPreset[] = ['none', '5mb']
export const FIVE_MB_TARGET_BYTES = 5 * 1024 * 1024
export const LEGACY_TARGET_SIZE_SOURCE = 'legacy-target-size'

export interface CompressionEntry {
  targetPreset: CompressionTargetPreset
  landingSource: CompressionLandingSource
}

export function resolveCompressionEntry(search: string): CompressionEntry {
  const params = new URLSearchParams(search)
  const targetPreset = params.get('target') === '5mb' ? '5mb' : 'none'
  const landingSource =
    targetPreset === '5mb' && params.get('source') === LEGACY_TARGET_SIZE_SOURCE
      ? 'legacy_redirect'
      : 'direct'
  return { targetPreset, landingSource }
}

export function resolveCompressionTargetPreset(search: string): CompressionTargetPreset {
  return resolveCompressionEntry(search).targetPreset
}

export function targetBytesForPreset(preset: CompressionTargetPreset): number | undefined {
  return preset === '5mb' ? FIVE_MB_TARGET_BYTES : undefined
}
